import moment from "moment";

import { CHART_HEADER_ACTIONS } from "constants/chartConstant";

import { ANAYTICS_CHART_DURATIONS } from "pages/Analytics/AnalyticsHelper/Analytics.const";

import ANALYTICS_ACTIONS from "../actionTypes/analytics";


const tagDataInitialState = {
  TagsWithoutData: [],
  PlotData: null
};

const tagsInitialState = {
  Alarms: [],
  OrignialAlarms: [],
  Duration: "",
  DurationRanges: {},
  Id: null,
  Tags: [],
  CurrentView: null,
  TagDefaultConfig: { Type: "lines+markers" },
  spike : false,
  ...tagDataInitialState
};

const initialState = {
  IsLoading: false,
  AlarmsHistory: [],
  ...tagsInitialState
};

const analyticsData = (state = initialState, action) => {
  switch (action.type) {
    case ANALYTICS_ACTIONS.SET_ANALYTICS_CHART_TAGS:
      return { ...state, Tags: action.payload };

    case ANALYTICS_ACTIONS.UPDATE_ANALYTICS_CHART_DURATION:
      let { Duration, DurationRanges } = action.payload;
      if (!DurationRanges) DurationRanges = getAnalyticsDurationRanges(Duration);
      const alarms = filterAlarmsWitninRanges(DurationRanges, state.AlarmsHistory, state.CurrentView);
      return { ...state, Duration, DurationRanges, ...alarms };

    case ANALYTICS_ACTIONS.SET_ANALYTICS_CHART_TAG_DATA_LOADING:
      return { ...state, IsLoading: action.payload };

    case ANALYTICS_ACTIONS.SET_ANALYTICS_CURRENT_EDITVIEW:
      const CurrentView = action.payload;
      const updateState = { ...state, CurrentView };
      if (CurrentView === CHART_HEADER_ACTIONS.EDIT_ALARMS) {
        updateState.OrignialAlarms = state.Alarms;
      }
      return updateState;

    case ANALYTICS_ACTIONS.SET_ANALYTICS_PLOT_DATA:
      return { ...state, ...action.payload };

    case ANALYTICS_ACTIONS.RESET_SPIKE_LINE:
      return{...state, spike: action.payload }

    case ANALYTICS_ACTIONS.SET_ALARMS_HISTORY:
      return setAlarmsHistory(state, action.payload);

    case ANALYTICS_ACTIONS.UPDATE_ANALYTICS_ALARMS:
      return onEditAlarms(state, action.payload);

    case ANALYTICS_ACTIONS.SAVE_ANALYTICS_ALARMS:
      return onSaveAlarms(state, action.payload);

    case ANALYTICS_ACTIONS.RESET_ANALYTICS_CHART_DATA:
      return initialState;

    default:
      return state;
  }
};

function getAnalyticsDurationRanges(duration) {
  duration = ANAYTICS_CHART_DURATIONS[duration] || duration;
  const [unit, differential] = duration.split(" ");
  const tempStartDate = moment().subtract(unit, `${differential}s`).toString();
  const startTime = Math.floor(moment(tempStartDate).valueOf() / 1000);
  const endTime = Math.floor(moment().valueOf() / 1000);
  return { startTime, endTime };
}

const filterAlarmsWitninRanges = (DurationRanges, Alarms, CurrentView) => {
  const { startTime, endTime } = DurationRanges;
  const result = { Alarms: [], OrignialAlarms: [] };
  const filterdList = [];
  if (startTime && endTime) {
    result.Alarms = Alarms.filter(({ TimeStamp }) => {
      const unixTime = moment(TimeStamp).unix();
      return startTime <= unixTime && unixTime <= endTime;
    });
  }
  if (CurrentView === CHART_HEADER_ACTIONS.EDIT_ALARMS) {
    result.OrignialAlarms = result.Alarms;
  }
  return result;
};

const setAlarmsHistory = (state, AlarmsHistory) => {
  const { DurationRanges, CurrentView } = state;
  const result = filterAlarmsWitninRanges(DurationRanges, AlarmsHistory, CurrentView);
  return { ...state, AlarmsHistory, ...result };
};

const onEditAlarms = (state, payload) => {
  const { updatedAlarms } = payload || {};
  let { OrignialAlarms, Alarms } = state;
  if (!updatedAlarms) {
    Alarms = OrignialAlarms;
    OrignialAlarms = [];
  } else {
    Alarms = updatedAlarms;
  }
  return { ...state, OrignialAlarms, Alarms };
};

const onSaveAlarms = (state, payload) => {
  const { Alarms, AlarmsHistory } = payload;
  const OrignialAlarms = [];
  return { ...state, Alarms, AlarmsHistory, OrignialAlarms };
};

export default analyticsData;
